import { irrigacao } from './genericos'

const ILPF = {
  area: '',
  dataInicio: '',
  modalidades: [],
  lavouras: [],
  pecuarias: [],
  florestas: [],
  utilizaBioinsumos: null,
  bioinsumos: [],
  possuiIrrigacao: null,
  irrigacao: {...irrigacao},
  financiamentos: [],
  outroFinanciamento: '',
  descricao: ''
}

export default ILPF



// WEBPACK FOOTER //
// ./src/libs/models/cadastro/praticas/ILPF.js